<template>
    <div class="condition-content">
        <compare-selector
            ref="statusSelector"
            :value="statusValue"
            :multiple="true"
            :options="options"
            :valid="statusValid"
            :placeholder="$t('请选择客户状态')"
            @change="onChangeStatus"
        />
        <compare-selector
            ref="timeRangeSelector"
            :value="holderValue"
            :multiple="true"
            :valid="timeValid"
            type="TIME_RANG_A"
            :placeholder="$t('请选择当前状态停留时长')"
            @change="onChangeHolder"
        />
    </div>
</template>

<script>
import CompareSelector from './plugins/compare-selector';

export default {
  name: 'CustomerStatus',

  components: {
    CompareSelector,
  },

  props: {
    optionInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    value: {
      type: Object,
      default() {
        return {
          ruleList: [{}, {}],
          logic: ['and'],
        };
      },
    },
    dataSource: {
      type: Object,
      default() {
        return {};
      },
    },
  },

  data() {
    const { statusValue, holderValue } = this.value;
    return {
      statusValue,
      holderValue,
      options: this.convertOptions(this.dataSource),
      statusValid: true,
      timeValid: true,
    };
  },

  computed: {
    brief() {
      const statusSelectText = this.getBriefText('statusSelector', this.statusValue);
      const timeRangeSelectText = this.getBriefText('timeRangeSelector', this.holderValue);
      if (!statusSelectText) {
        return undefined;
      }
      return this.$t('{text}为{status}并且停留时长为{time}', { text: this.optionInfo.text, status: statusSelectText, time: timeRangeSelectText });
    },
  },

  watch: {
    dataSource(newValue) {
      this.options = this.convertOptions(newValue);
    },
  },

  mounted() {
    this.onChange(this.currentValue);
  },

  methods: {
    validate() {
      this.statusValid = !!this.statusValue;
      this.timeValid = !!this.holderValue;
      return !!(this.timeValid && this.statusValid);
    },
    onChangeStatus(value) {
      this.statusValid = true;
      this.statusValue = value;
      this.onChange();
    },
    onChangeHolder(value) {
      this.timeValid = true;
      this.holderValue = value;
      this.onChange();
    },
    onChange() {
      const ruleData = this.getRuleData();
      const showVal = {
        statusValue: this.statusValue,
        holderValue: this.holderValue,
      };
      this.$emit('change', {
        ruleData,
        showVal,
        brief: this.brief,
        validation: !!(this.statusValue && this.holderValue),
      });
    },
    getRuleData() {
      const ruleConditions = [
        { name: 'customerStatusBeginTime', value: 7, type: 'int', operation: '<=' },
        {
          fieldConditionList: [
            { value: 8, operation: '>=', name: 'customerStatusBeginTime', type: 'int' },
            { value: 15, operation: '<', name: 'customerStatusBeginTime', type: 'int' },
          ],
          relation: 'and',
        },
        {
          fieldConditionList: [
            { value: 15, operation: '>=', name: 'customerStatusBeginTime', type: 'int' },
            { value: 30, operation: '<', name: 'customerStatusBeginTime', type: 'int' },
          ],
          relation: 'and',
        },
        { name: 'customerStatusBeginTime', value: 30, type: 'int', operation: '>0' },
      ];
      let stayConditions;
      if (this.holderValue && this.holderValue.indexOf(4) === -1) {
        stayConditions = {
          fieldConditionList: this.holderValue.map(i => ruleConditions[i]),
          relation: 'or',
        };
      }
      const fieldConditionList = [
        {
          name: 'customerStatusID',
          value: JSON.stringify(this.statusValue),
          type: 'array',
          operation: 'arrayInclude',
        },
      ];
      if (stayConditions) {
        fieldConditionList.push(stayConditions);
      }
      return {
        name: 'customerStatus',
        relation: 'and',
        fieldConditionList,
      };
    },
    convertOptions(dataSource) {
      let options = [];
      const originOptions = dataSource ? dataSource.followAttr : [];
      options = originOptions.map(item => ({
        text: item.name,
        value: item.aid,
      }));
      return options;
    },
    getBriefText(ref, selectedValue) {
      return selectedValue
        ? this.$refs[ref].currentOptions
          .filter(obj => selectedValue.indexOf(obj.value) > -1)
          .map(item => item.text)
          .join(',')
        : '';
    },
  },
};
</script>
